export default __webpack_public_path__ + "static/media/demo_1.18e52eba.webm";